import { createAsyncThunk } from '@reduxjs/toolkit';
import request from '../../request/request';

export const getUserDetailAction = createAsyncThunk('userDetail', async (object, { rejectWithValue }) => {
  const response = await request(`/api/v1/tenants/user-list/${object.tenantId}`, { method: 'GET' , auth: true});

  if (response?.data) {
    return response;
  }
  const { error } = response;
  throw rejectWithValue(error || 'Something went wrong');
});